const prodTokenListUrl = [
    'https://raw.githubusercontent.com/BitSwapFinance/BitSwap-tokenList/main/build/tokenList.json',
    'https://tokenlist.bitswap.site/tokenList.json',
];

const devTokenListUrl = [
    'https://raw.githubusercontent.com/BitSwapFinance/BitSwap-tokenList/main/build/tokenListDev.json',
    'https://tokenlist.bitswap.site/tokenListDev.json',
];

export const tokenListUrl = process.env.REACT_APP_ENV === 'production' ? prodTokenListUrl : devTokenListUrl;
